module.exports = "<div>\r\n  <label>{{\"NETWORK.URL_LABEL\" | translate}}</label>\r\n  <app-input [formGroup]=\"blogForm\" inputName=\"blogUrl\" [(data)]=\"data.url\" maxLength=\"200\"\r\n             (enterPressed)=\"enterPressed.emit()\" [formIndex]=\"formIndex\"\r\n             placeholder=\"{{'NETWORK.BLOG_PLACEHOLDER_URL' | translate}}\"></app-input>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/network/blog-item/blog-item.component.html
// module id = ../../../../../src/app/network/blog-item/blog-item.component.html
// module chunks = main